/** Display order for the tech stack section; labels come from i18n `techNames`. */
export const techStackOrder = [
  'java',
  'javascript',
  'php',
  'react',
  'jquery',
  'docker',
  'kubernetes',
  'python',
  'sql',
  'springboot',
  'c',
];
